

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"viewBox":"0 0 9 8"}, rest), ["\n  ", h('path', {"fill":"currentColor","fill-rule":"nonzero","d":"m3.048 6.947-2.83-2.83a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l2.3 2.3L7.482.402c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06L4.107 6.947a.75.75 0 0 1-1.06 0Z"}, []), "\n"]);
};

        